/**
 * Phase 24.4a — Skeleton primitive.
 *
 * Pulsing placeholder for loading states. Composable via className for
 * width/height. Accessibility: aria-busy + aria-hidden on decoration.
 *
 * Usage:
 *   <Skeleton className="h-32 w-full" />       // card-shape
 *   <Skeleton className="h-4 w-24" />           // text-line shape
 */
import { cn } from "@/lib/utils";

interface Props {
  className?: string;
  /** ARIA label for the loading region. Defaults to "Loading". */
  label?: string;
}

export function Skeleton({ className, label = "Loading" }: Props) {
  return (
    <div
      className={cn("animate-pulse rounded bg-cream-border", className)}
      aria-busy="true"
      aria-label={label}
      data-testid="skeleton"
    />
  );
}
